import { Component, ContentChild, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'rt-add-line',
  templateUrl: 'add-line.component.html',
  styleUrls: ['./add-line.component.less'],
})
export class AddLineComponent {
  @ContentChild(TemplateRef, { static: true })
  public set onTemplateRef(templateRef: TemplateRef<any>) {
    this.iconTemplate = templateRef;
  }

  @Input() public disabled: boolean;
  public iconTemplate: TemplateRef<any>;
}
